import { IMachineSettingsDateFilter } from 'interfaces/i-machine-settings';

export enum ShotHistoryTableMode {
  Training = 'Training',
  BP = 'BP',
}

export enum ShotHistoryTableConfidence {
  High = 'High',
  Low = 'Low',
}

export enum ShotHistoryTableStaticValues {
  True = 'True',
  False = 'False',
}

// Working type as used in the ShotHistory table. See IGatherShotDataQuery for type sent to the server.
export interface IShotHistoryTableFilters {
  dateRange?: IMachineSettingsDateFilter;
  mode: ShotHistoryTableMode | '';
  confidence: ShotHistoryTableConfidence | '';
  hasVideo: ShotHistoryTableStaticValues | '';
  pitchName: string;
  hitterID: string;
}

export interface IMissedDetectionsTableFilters {
  dateRange?: IMachineSettingsDateFilter;
  pitchName: string;
  message: string;
}
